/** Logo is the SVENEX logo with the leaf, for wherever the brand appears
 *  (not inside sentences). `mark` is the leaf alone, for tight spaces. */
export function Logo({ mark = false, className = "" }: { mark?: boolean; className?: string }) {
  return mark
    ? <img className={`logo-mark ${className}`} src="/mark.svg" alt="SVENEX" width={22} height={22} />
    : <img className={`logo ${className}`} src="/logo.svg" alt="SVENEX" width={96} height={19} />;
}
